const REQUEST_DEVICE_SETTING = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_DEVICE_SETTING = (state, { body }) => {
  state.status = "success";
  state.DeviceSetting = body;
};

const FAILURE_REQUEST_DEVICE_SETTING = state => {
  state.status = "failure";
};

const REQUEST_UPDATE_DEVICE_SETTING = state => {
  state.statusUpdate = "fetching";
};

const SUCCESS_REQUEST_UPDATE_DEVICE_SETTING = state => {
  state.statusUpdate = "success";
};

const FAILURE_REQUEST_UPDATE_DEVICE_SETTING = state => {
  state.statusUpdate = "failure";
};

const REQUEST_CREATE_DEVICE_SETTING = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_CREATE_DEVICE_SETTING = state => {
  state.statusCreate = "success";
};

const FAILURE_REQUEST_CREATE_DEVICE_SETTING = state => {
  state.statusCreate = "failure";
};

export default {
  REQUEST_DEVICE_SETTING,
  SUCCESS_REQUEST_DEVICE_SETTING,
  FAILURE_REQUEST_DEVICE_SETTING,
  REQUEST_UPDATE_DEVICE_SETTING,
  SUCCESS_REQUEST_UPDATE_DEVICE_SETTING,
  FAILURE_REQUEST_UPDATE_DEVICE_SETTING,
  REQUEST_CREATE_DEVICE_SETTING,
  SUCCESS_REQUEST_CREATE_DEVICE_SETTING,
  FAILURE_REQUEST_CREATE_DEVICE_SETTING,
};
